import {AbstractStripePaymentRequestPayment} from './abstract/class-abstract-stripe-paymentrequest-payment';

class StripeApplepayPayment extends AbstractStripePaymentRequestPayment {
	public gatewayId(): string {
		return 'peachpay_stripe_applepay';
	}

	protected paymentRequestType(): 'googlePay' | 'applePay' {
		return 'applePay';
	}
}

export {StripeApplepayPayment};
